import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {getApiBaseForObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {UpdateArchivableParams} from 'app-core/platform/archivable/CoreObjectArchiveConstants';
import {patchJSONPromise} from 'util/Net';

export interface UpdateWorksheetStep {
  documentId?: string;
  name?: string;
  fromId?: string;
}

export interface UpdateWorksheetStepGroup {
  steps: Array<UpdateWorksheetStep>;
}

export interface UpdateWorksheetParams extends UpdateArchivableParams {
  id: string;
  stepGroups?: Array<UpdateWorksheetStepGroup>;
}

export interface UpdateWorksheetsResponse {
  updatedIds: Array<string>;
}

export function updateWorksheets(updates: Array<UpdateWorksheetParams>): Promise<UpdateWorksheetsResponse> {
  return patchJSONPromise({
    url: getApiBaseForObjectType(DomainGraphType.WORKSHEET),
    data: {updates},
  });
}

export interface AddStepToWorksheetResponse {
  updatedWorksheetId: string;
}
